import React, { useEffect, useState } from "react";
import { Upload, Button, Table, Select, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { getImportSchema, importHostData } from "../api/import";

const { Option } = Select;

export default function ExcelImport() {
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [mapping, setMapping] = useState({});
  const [dbFields, setDbFields] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState(null);

  function fetchSchema(Schema) {
    getImportSchema(Schema).then((res) => {
      setDbFields(res.data);
      setSelectedSchema(Schema);
    });
  }
  // 读取 Excel
  const beforeUpload = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const workbook = XLSX.read(e.target?.result, {
        type: "binary",
        cellDates: true,
      });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(sheet) || [];
      console.log("Excel 数据:", json);
      if (!json.length) {
        message.error("Excel 里没有数据");
        return;
      }

      // 表头
      const excelHeaders = Object.keys(json[0] || {});

      setColumns(
        excelHeaders.map((key) => ({
          title: key,
          dataIndex: key,
        }))
      );

      setDataSource(json.map((row, index) => ({ ...(row || {}), key: index })));
    };

    reader.readAsBinaryString(file);
    return false; // 阻止自动上传
  };

  // 提交
  const submit = async () => {
    const formattedData = dataSource.map((row) => {
      const obj = {};
      Object.keys(mapping).forEach((excelKey) => {
        obj[mapping[excelKey]] = row[excelKey];
      });
      return obj;
    });
    const res = await importHostData(formattedData);
    const result = res.data;
    if (result.statusCode && result.statusCode !== 200) {
      message.error(`导入失败: ${result.msg}`);
      return;
    } else {
      message.success(`成功导入 ${result.count} 条数据`);
    }
  };

  return (
    <div>
      <Upload beforeUpload={beforeUpload} showUploadList={false}>
        <Button icon={<UploadOutlined />}>上传 Excel</Button>
      </Upload>
      <Select
        style={{ width: 200, margin: "16px 0" }}
        placeholder="选择数据表"
        onChange={fetchSchema}
      >
        <Option value="Host">Host</Option>
        <Option value="HostRentContract">HostRentContract</Option>
        <Option value="User">User</Option>
      </Select>

      {/* 字段映射 */}
      {columns.length > 0 && (
        <div style={{ margin: "16px 0" }}>
          <h3>字段映射</h3>
          {columns.map((col) => (
            <div key={col.dataIndex} style={{ marginBottom: 8 }}>
              <span style={{ marginRight: 8 }}>{col.title}</span>
              <Select
                style={{ width: 200 }}
                placeholder="选择数据库字段"
                onChange={(value) =>
                  setMapping({ ...mapping, [col.dataIndex]: value })
                }
              >
                {dbFields.map((f) => (
                  <Option key={f.name} value={f.name}>
                    {f.name} ({f.type})
                  </Option>
                ))}
              </Select>
            </div>
          ))}
        </div>
      )}

      {/* 数据预览 */}
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 5 }}
      />

      {dataSource.length > 0 && (
        <Button type="primary" onClick={submit}>
          确认导入
        </Button>
      )}
    </div>
  );
}
